module.exports = function() {
  return new Worker(__webpack_public_path__ + "b274dfc87be2c63c42c8.worker.js");
};